import { render } from "./comp-menu.vue?vue&type=template&id=46b31054&ts=true"
import script from "./comp-menu.vue?vue&type=script&lang=ts"
export * from "./comp-menu.vue?vue&type=script&lang=ts"

import "./comp-menu.vue?vue&type=style&index=0&id=46b31054&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__